import { render, staticRenderFns } from "./ArpsRpsAnsDownload.vue?vue&type=template&id=a678477a&scoped=true"
import script from "./ArpsRpsAnsDownload.vue?vue&type=script&lang=js"
export * from "./ArpsRpsAnsDownload.vue?vue&type=script&lang=js"
import style0 from "./ArpsRpsAnsDownload.vue?vue&type=style&index=0&id=a678477a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a678477a",
  null
  
)

export default component.exports